<div class="header">
  <div class="mat-h2">{{ 'BRANCH_USERS_HEADER.branches' | translate }}</div>
  <div>
    <mat-form-field floatLabel="always" appearance="outline" >
      <mat-label class="mat-label">{{ 'SEARCH.search' | translate }}</mat-label>
      <input
        id="search"
        #search
        matInput
        (keyup)="monitorSearch(search.value)"
        placeholder="{{ 'COMPANY_BRANCHES.searchPlaceholder' | translate }}"
      />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>
</div>

@if (noRecordFound) {
<app-not-found [displayMessage]="message"></app-not-found>
}

<table mat-table [dataSource]="companyBranchesDataSource" [ngClass]="noRecordFound ? 'hide' : ''">
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef width="40%">
      {{ 'COMPANY_BRANCHES.name' | translate }}
    </th>
    <td
      mat-cell
      *matCellDef="let companyBranch"
    >
      {{ companyBranch.name }}
      @if (!companyBranch.parentAccountId) {
      <mat-chip class="headquarter-chip">{{
        'COMPANY_BRANCHES.headQuarters' | translate
      }}</mat-chip>
      }
      @if (isEqual(companyBranch.status, 'Inactive')) {
      <mat-chip class="closed-branch-chip">{{
        'COMPANY_BRANCHES.closedHeadingTitle' | translate
      }}</mat-chip>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="address">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'COMPANY_BRANCHES.address' | translate }}
    </th>
    <td
      mat-cell
      *matCellDef="let companyBranch"
    >
      {{ companyBranch.address }}
    </td>
  </ng-container>

  <ng-container matColumnDef="sectorNumber">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'COMPANY_BRANCHES.sectorNumber' | translate }}
    </th>
    <td
      mat-cell
      *matCellDef="let companyBranch"
    >
      {{ companyBranch.sectorNumber }}
    </td>
  </ng-container>

  <ng-container matColumnDef="location">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'COMPANY_BRANCHES.location' | translate }}
    </th>
    <td
      mat-cell
      *matCellDef="let companyBranch"
    >
      {{ companyBranch.location }}
    </td>
  </ng-container>

  <ng-container matColumnDef="employeeCount">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'COMPANY_BRANCHES.employee_count' | translate }}
    </th>
    <td
      mat-cell
      *matCellDef="let companyBranch"
    >
      {{ companyBranch.employeeCount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="branchAdmins">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'COMPANY_BRANCHES.branchAdmin' | translate }}
    </th>
    <td
      mat-cell
      *matCellDef="let companyBranch"
    >
      <a (click)="$event.stopPropagation(); navigateToBranchAdmins(companyBranch)">
        {{
          companyBranch.branchAdmins?.length > 1
            ? companyBranch.branchAdmins?.length +
              ' ' +
              ('COMPANY_BRANCHES.admins' | translate | titlecase)
            : companyBranch.branchAdmins?.length + ' ' + ('COMPANY_BRANCHES.admin' | translate | titlecase)
        }}
      </a>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
    (click)="$event.stopPropagation(); handleRowClick(row)"
  ></tr>
</table>
@if (!noRecordFound) {
<mat-paginator
  [showFirstLastButtons]="true"
  [pageSizeOptions]="[10, 25, 50, 100]"
></mat-paginator>
}

@if (loading) {
<app-spinner></app-spinner>
}
